import _Promise from "@babel/runtime-corejs2/core-js/promise";
export var mockedFetchProductsActivationInfo = function mockedFetchProductsActivationInfo() {
  return _Promise.resolve({
    products: {
      appoptics: 'can_activate',
      loggly: 'access_needed',
      papertrail: 'can_activate',
      pingdom: 'can_activate'
    },
    hasCombinedNavigation: true
  });
};